module.exports = __webpack_public_path__ + "img/face-graphic.f78469ec.png";